import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import Caption from '../../../../Theme/Fonts/Caption'
import Affiliation from '../Affiliation'
import { SquadPlayerItemProps } from '..'
import PlayerImage from '../../../../BaseComponents/Image/Player'

const getPlayerCaption = (jerseyNumber?: number | string, age?: number | string) => {
    let caption
    if (jerseyNumber && age) {
        caption = `${age} Jahre | Trikotnummer: ${jerseyNumber}`
    } else if (age) {
        caption = `${age} Jahre`
    } else if (jerseyNumber) {
        caption = `Trikotnummer: ${jerseyNumber}`
    }
    return caption
}

const PlayerInfo: FunctionComponent<
    Omit<SquadPlayerItemProps, 'isFavorite' | 'onPress' | 'onFavorite' | 'TestID'>
> = ({
    imageUrl,
    alt,
    firstName,
    lastName,
    nickName,
    age,
    jerseyNumber,
    firstAffiliation,
    secondAffiliation,
}): ReactElement => {
    const caption = getPlayerCaption(jerseyNumber, age)
    return (
        <Grid horizontal centerVertical height={48} paddingLeft={5}>
            <PlayerImage imageUrl={imageUrl} alt={alt} width={48} size="S" />
            <Grid marginLeft={3} paddingY={4} minWidth={0}>
                <Grid minWidth={0}>
                    <SmallBodyFont color="onyx" numberOfLines={1}>
                        {nickName || `${lastName}, ${firstName}`}
                    </SmallBodyFont>
                </Grid>
                {caption ? (
                    <Grid minWidth={0}>
                        <Caption color="keshi-4" numberOfLines={1}>
                            {caption}
                        </Caption>
                    </Grid>
                ) : null}
                <Grid horizontal>
                    <Affiliation {...firstAffiliation} />
                    {secondAffiliation ? <Affiliation {...secondAffiliation} /> : null}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PlayerInfo
